import { getQuizResultsTexts } from "./quiz-results-texts.js";

/**
 * Blurb API settings are kept as-is to preserve current behavior.
 * Security hardening is intentionally postponed.
 */
const BLURB_API_URL =
  "https://us-central1-buoyant-genre-266713.cloudfunctions.net/results_blurbs";
const BLURB_API_KEY =
  "mgAcnuO2xyC2zqN2hzMq2nUcQ6ASZ9fl40MWxPfh999VAvXQ80CCAv5FhzbGQFGIbC5JU6xxaPFHDzeAhRPOU9t6Z9uezJalyoQYb5hMEVZyukzp8kfciPT0Kb33c36c";

/**
 * Escape user/content text before HTML injection.
 *
 * @param {any} value
 * @returns {string}
 */
function escapeHtml(value) {
  return String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");
}

/**
 * Build loading markup (analog of Angular app-blurb loading state).
 */
function getBlurbLoadingHtml() {
  const texts = getQuizResultsTexts();
  return `
    <div class="quiz-results-intro-text-box-loading">
      <span class="ajax-preloader loading"></span>
      <span>${escapeHtml(texts.blurb.loadingText)}</span>
    </div>
  `.trim();
}

/**
 * Build loaded markup (analog of Angular app-blurb content state).
 *
 * @param {any} blurbText
 * @returns {string}
 */
function getBlurbContentHtml(blurbText) {
  const texts = getQuizResultsTexts();
  return `
    <div class="quiz-results-intro-text-box-title">
      ${escapeHtml(texts.blurb.title)}
    </div>
    <div class="quiz-results-intro-text-box-text">
      ${escapeHtml(blurbText)}
    </div>
    <div class="quiz-results-intro-text-box-bottom">
      ${escapeHtml(texts.blurb.bottomNote)}
    </div>
  `.trim();
}

/**
 * Render blurb block into target container.
 *
 * @param {Element | null} container
 * @param {{ isLoading: boolean, text: string }} options
 */
export function renderBlurbBlock(container, options) {
  const { isLoading, text } = options;
  if (!container) return;
  container.innerHTML = isLoading
    ? getBlurbLoadingHtml()
    : getBlurbContentHtml(text || "");
}

/**
 * Fetch blurb text from API based on quiz answers and regimen title.
 *
 * @param {{ results: any, regimenProduct: any }} params
 * @returns {Promise<string>}
 */
export async function fetchBlurbText(params) {
  const { results, regimenProduct } = params;
  if (!results) return "";

  const payload = {
    sensitivity: results?.answers?.Sensitivity,
    concerns: results?.answers?.Concerns,
    regimen: regimenProduct?.title,
  };

  try {
    const response = await fetch(BLURB_API_URL, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        "x-api-key": BLURB_API_KEY,
      }),
      body: JSON.stringify(payload),
    });
    const data = await response.json();
    return data?.blurb || "";
  } catch (_error) {
    return "";
  }
}
